module.exports = __webpack_public_path__ + "static/together_sec2_img0_m-a814a7ea8d4fab06c73832ceff785984.png";